import React from 'react';

import ReactDOM from 'react-dom';
import { Button, Modal } from 'components';

type ConfirmMustCallModalProps = {
  onConfirm: () => void;
  onCancel: () => void;
  canSubscribeToAnsweringService: boolean;
};
// @ts-ignore: open is assigned during render
const ConfirmMustCallModal: React.FC & {
  open: (props: ConfirmMustCallModalProps) => void;
} = () => {
  const props = React.useRef<ConfirmMustCallModalProps | null>();
  const [open, setOpen] = React.useState(false);
  ConfirmMustCallModal.open = React.useCallback(newProps => {
    props.current = newProps;
    setOpen(true);
  }, []);

  return (
    <Modal
      title={
        props.current?.canSubscribeToAnsweringService
          ? 'Live Concierge Service'
          : 'Must Call'
      }
      open={open}
      onCancel={() => {
        setOpen(false);
        props.current?.onCancel();
      }}
      footer={
        <div>
          {props.current?.canSubscribeToAnsweringService && (
            <Button
              onClick={() => {
                setOpen(false);
                props.current?.onCancel();
              }}
            >
              Cancel
            </Button>
          )}
          <Button
            type="primary"
            onClick={async () => {
              props.current?.onConfirm();
              setOpen(false);
            }}
          >
            {props.current?.canSubscribeToAnsweringService ? (
              <>Go to Live Concierge Page</>
            ) : (
              <>I Acknowledge</>
            )}
          </Button>
        </div>
      }
    >
      {props.current?.canSubscribeToAnsweringService ? (
        <>
          You have indicated that a listing contact requires a physical phone
          call to confirm this showing. You do not have Live Concierge set up
          and therefore cannot perform this action. Please subscribe to the
          concierge service to make sure the showing can be confirmed.
        </>
      ) : (
        <>
          You have indicated that a listing contact requires a physical phone
          call to confirm this showing. This listing is not associated to a
          brokerage with Live Concierge service set up and therefore cannot
          perform this action.
        </>
      )}
    </Modal>
  );
};

// put the modal in a root so that it can be opened from angular without react2angular
ReactDOM.render(<ConfirmMustCallModal />, document.createElement('div'));

export default { open: ConfirmMustCallModal.open };
